<template>
  <div>
    <div class="d-flex align-items-center bg-light manage-header">
      <h4 class="m-0">Manage</h4>
    </div>
    <div class="border-top"></div>

    <ErrorDisplay :value="error" class="m-3"/>

    <div v-if="loading" class="text-center text-secondary py-2">
      <b-spinner small/>
    </div>

    <b-list-group v-else flush class="border-bottom mb-3">
      <b-list-group-item
        v-for="(item, key) in items"
        :key="key"
        :to="`/manage/${key}`"
        active-class="active"
        class="d-flex justify-content-between align-items-center"
      >
        {{typePlural(key)}}
        <span v-if="badges[key]" class="badge badge-pill badge-light">{{badges[key]}}</span>
      </b-list-group-item>
      <b-list-group-item
        v-if="items"
        to="/manage/payment-due"
        active-class="active"
        class="d-flex justify-content-between align-items-center"
      >
        Payments Due
        <span v-if="badges['payment-due']" class="badge badge-pill badge-light">{{badges['payment-due']}}</span>
      </b-list-group-item>
      <b-list-group-item
        v-if="items"
        to="/manage/artist-payment"
        active-class="active"
      >Artist Payments</b-list-group-item>
      <b-list-group-item
        v-if="items"
        to="/manage/image"
        active-class="active"
        class="d-flex justify-content-between align-items-center"
      >
        Images
        <span v-if="badges.image" class="badge badge-pill badge-light">{{badges.image}}</span>
        <ArrowBothIcon v-else class="fill-color"/>
      </b-list-group-item>
      <b-list-group-item
        v-if="items"
        to="/manage/royalty-levels"
        active-class="active"
        class="d-flex justify-content-between align-items-center"
      >
        Royalty Levels
        <ArrowBothIcon class="fill-color"/>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { omit } from 'lodash'

import ArrowBothIcon from '@primer/octicons/build/svg/arrow-both-16.svg'

import { http } from '@/services/http.js'
import { typePlural } from '@/pages/_type/index.vue'

export default {
  name: 'ManageMenu',
  components: {
    ArrowBothIcon,
  },
  data() {
    return {
      error: null,
      blacklist: [
        'sample-image',
        'artist-payment',
      ],
      items: null,
      loading: null,
    }
  },
  computed: {
    // key -> pending count, e.g. {upload: 3}. Fetching lives centrally in
    // pages/manage.vue (see store/modules/badges.js) — this menu just displays.
    badges() { return this.$store.state.badges.counts },
  },
  async created() {
    this.loading = true
    this.items = await http.get(`api/`)
      .then(response => response.data)
      .then(data => omit(data, this.blacklist))
      .catch(err => {
        this.error = err
        throw err
      })
      .finally(() => this.loading = false)
  },
  methods: {
    typePlural,
  },
}
</script>
